import { getVisitorCat } from "@components/GAData/helper";
import {
  REGISTERED_FLAGS,
  SUBSCRIBER_FLAGS,
} from "@features/mySph/utils/constants";
import {
  FeedSSOUserDetailsResponse,
  SanitizedUserInfoObject,
  UserRegistrationStatusEnum,
  UserTypeEnum,
} from "@features/mySph/utils/types";
import { User } from "@sphtech/idpf-lightbox-react";

/**
 * Helper function to determine user type based on service flags
 * @param serviceFlags - Array of string retrieves from lightbox data
 */
export const getUserType = (serviceFlags: string[]) => {
  const isSubscriber = serviceFlags.some((flag) =>
    SUBSCRIBER_FLAGS.includes(flag)
  );

  const isRegistered =
    serviceFlags.some((flag) => REGISTERED_FLAGS.includes(flag)) ||
    serviceFlags.some((flag) => flag.startsWith("reg_"));

  if (isSubscriber) return UserTypeEnum.SUBSCRIBER;

  if (isRegistered) return UserTypeEnum.REGISTERED;

  return UserTypeEnum.ANONYMOUS;
};

/*
 * Helper function to get user's display name
 */
export const getDisplayName = (
  loginId: string,
  firstName?: string,
  lastName?: string
) => {
  if (!loginId && !firstName && !lastName) return "";

  if (!firstName && !lastName) return loginId;

  if (firstName && !lastName) return firstName;

  if (!firstName && lastName) return lastName;

  return `${firstName?.trim()} ${lastName?.trim()}`;
};

/**
 * Helper function to get the sanitized user info object
 */
export const getSanitizedUserInfoObject = (
  userInfo: User | FeedSSOUserDetailsResponse
): SanitizedUserInfoObject => {
  const registrationStatus = userInfo?.userStatus as UserRegistrationStatusEnum;
  const userType = getUserType(userInfo?.serviceFlags || []);
  const visitorCat = getVisitorCat(
    userType,
    registrationStatus,
    userInfo.serviceFlags
  );
  const displayName = getDisplayName(
    userInfo.loginId,
    userInfo.firstName,
    userInfo.lastName
  );

  return {
    loginId: userInfo.loginId || "",
    email: userInfo.email || "",
    firstName: userInfo.firstName || "",
    lastName: userInfo.lastName || "",
    visitorId: userInfo.visitorId || "",
    serviceFlags: userInfo.serviceFlags || [],
    userStatus: (userInfo.userStatus as UserRegistrationStatusEnum) || "",
    visitorcat: visitorCat,
    displayName: displayName,
    userType: userType as UserTypeEnum,
  };
};
